import { NewMapEditor } from "@/components/map/NewMapEditor";
import ResourceSettingsProvider from "@/hooks/useResourceSettings";
import { useMap } from "@webV2/map/MapProvider";
import { MapActions } from "@webV2/map/MapView/MapActions";
import { MapViewEditorPanel } from "@webV2/map/MapView/MapViewEditorPanel";
import { MapViewSvg } from "@webV2/map/MapView/MapViewSvg/MapViewSvg";
import React from "react";
import { UseMapViewSvgEditReturn } from "./MapViewSvg/useMapViewSvgEdit";

export interface MapViewProps {
  embedded?: boolean;
  editor?: UseMapViewSvgEditReturn;
  isModal?: boolean;
  isOnReservationModal?: boolean;
}

export const MapView: React.FC<MapViewProps> = ({
  isOnReservationModal,
  embedded,
  editor,
  isModal
}) => {
  const { floor, isMapBuilderMap, forceMapBuilder } = useMap();

  return (
    <React.Fragment key={forceMapBuilder ? "forceMapBuilder" : "default"}>
      <div className="full-map-container relative flex h-full flex-row justify-between">
        <div className="isolate w-full">
          {/* The Map */}
          <MapViewSvg
            editor={editor}
            embedded={embedded}
            isOnReservationModal={isOnReservationModal}
          />
          {editor?.isResourcePanelEditorOpen && (
            <ResourceSettingsProvider>
              <MapViewEditorPanel
                editor={editor}
                onMapEditorSaved={() => null}
              />
            </ResourceSettingsProvider>
          )}
          {editor?.isMapBuilderEditorOpen && floor && isMapBuilderMap && (
            <NewMapEditor
              editorRef={editor?.setMMapBuilderRef as never}
              floor={floor}
              key={floor.id}
              setEditingResources={(value) => {
                editor.setMapResourcesEditOptions({
                  isOpen: value.isOpen,
                  resourceIds: [...(value.resourceIds || [])].reverse()
                });
              }}
              editingResources={editor.mapResourcesEditOptions}
            />
          )}
          {!!floor && !isModal && (
            <div className={"fixed top-4 right-1"}>
              <MapActions editor={editor} />
            </div>
          )}
        </div>
      </div>
    </React.Fragment>
  );
};
